import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import { useUsersApi } from './use-users'

export function useGetUserKcProfile() {
  const { getUserKcProfile } = useUsersApi()

  return useQuery({
    queryKey: ['user-kc-profile'],
    queryFn: () => getUserKcProfile(),
  })
}

export function useGetUserMetrics() {
  const { getUserMetrics } = useUsersApi()

  return useQuery({
    queryKey: ['user-metrics'],
    queryFn: () => getUserMetrics(),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    staleTime: 1000 * 60 * 5,
  })
}
